var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-page-form',{attrs:{"data":_vm.landingPage,"title":_vm.$t('searchSuggestions.edit.title', { name: _vm.landingPage ? _vm.landingPage.title : ''}),"submit-loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }